var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index"},[_c('header-top'),_c('main-center')],1)}
var staticRenderFns = []

export { render, staticRenderFns }